"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerType = void 0;
var CustomerType;
(function (CustomerType) {
    CustomerType[CustomerType["PRIVATE"] = 0] = "PRIVATE";
    CustomerType[CustomerType["BUSINESS"] = 1] = "BUSINESS";
})(CustomerType = exports.CustomerType || (exports.CustomerType = {}));
//# sourceMappingURL=customerType.enum.js.map